import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BubbleTreeUiComponent } from './bubble-tree-ui/bubble-tree-ui.component';
import { DndModule } from 'ngx-drag-drop';
import { ThemeModule } from '../@theme/theme.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { CustomerHierarchyComponent } from './customer-hierarchy/customer-hierarchy.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MatSelectModule } from '@angular/material/select';
import { ngxLoadingAnimationTypes, NgxLoadingModule } from 'ngx-loading';

@NgModule({
  declarations: [BubbleTreeUiComponent, CustomerHierarchyComponent],
  imports: [
    CommonModule,
    DndModule,
    ThemeModule,
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
    MatIconModule,
    NgMultiSelectDropDownModule.forRoot(),
    MatSelectModule,
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.circle,
      backdropBackgroundColour: 'rgba(0,0,0,0.1)',
      backdropBorderRadius: '4px',
      primaryColour: '#8edd80',
      secondaryColour: '#ffffff',
      tertiaryColour: '#ffffff',
    }),
  ],
  exports: [
    BubbleTreeUiComponent,
    CustomerHierarchyComponent,
  ],
})
export class ShareModuleModule { }
